import * as React from 'react';
import type { SVGProps } from 'react';
const IconTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconTick"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.025 15.718-4.95-4.95-1.414 1.414 6.364 6.364L21.34 7.232l-1.414-1.414z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconTick;
